<template>
  <svg version="1.1" viewBox="0 0 7529.57 4774.61" class="img-card" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2266561068528">
        <g>
          <image style="width:100%;" :href="typeCard" />
        </g>
      </g>
    </g>

    <text v-if="virtual" id="virtual" font-family="Roboto-Medium, Roboto" font-size="450" font-weight="800" :fill="cardColor">
      <tspan x="5500" y="700">{{ "Virtual" }}</tspan>
    </text>

    <text id="Solde-:-295,23€" font-family="Roboto-Regular, Roboto" font-size="450" font-weight="normal" fill="#000">
      <tspan id="solde" x="300" y="3000">
        {{ $t("title.soldLabel") }} {{ amountLeft }} lei
      </tspan>
    </text>
    <text id="Mathieu-Chabasse-Exp-Copy-2" font-family="Roboto-Regular, Roboto" font-size="350" font-weight="normal"
      fill="#000">
      <tspan x="300" y="3800">{{ embossName }}</tspan>
      <tspan x="300" y="4300">
        {{ $t("title.expireAtLabel") }} {{ expireLabel }}
      </tspan>
    </text>
    <text id="xxxx-xxxx-xxxx-xxxx-copy" font-family="Roboto-Medium, Roboto" font-size="350" font-weight="400" fill="#000">
      <tspan x="300" y="2400">{{ cardPan }}</tspan>
    </text>
  </svg>
</template>

<script>
// import CardIcons11 from "../images/svg/card_up_icons_11.vue";
// import CardIcons12 from "../images/svg/card_up_icons_12.vue";
// import CardIcons13 from "../images/svg/card_up_icons_13.vue";
// import CardIcons14 from "../images/svg/card_up_icons_14.vue";
// import CardIcons1523 from "../images/svg/card_up_icons_1523.vue";

export default {
  components: {
    // CardIcons11,
    // CardIcons12,
    // CardIcons13,
    // CardIcons14,
    // CardIcons1523
  },
  props: {
    msg: String,
    amountLeft: {
      type: String,
      default: "0,00"
    },
    embossName: {
      type: String,
      default: "0"
    },
    expireLabel: {
      type: String,
      default: "0"
    },
    cardPan: {
      type: String,
      default: "0000 0000 0000 0000"
    },
    product: {
      type: Number,
      default: 14
    },
    virtual: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    cardColor() {
      if (this.product === 11) {
        return "#F59100";
      } else if (this.product === 12) {
        return "#c61b10";
      } else {
        return "";
      }
    },
    typeCard() {
      let config = JSON.parse(sessionStorage.getItem("mobile_jsonFile"));
      for (let index in config.cards) {
        if (config.cards[index].product === this.product) {
          return config.cards[index].image;
        }
      }

      return require("../../assets/images/logo-up-" + this.product + ".png");
    },
    productText() {
      if (this.product === 11) {
        return "M99.6281776,35.9786353 L103.256261,35.7506026 L103.256261,27.5118967 C103.256261,25.6876353 104.312808,23.9470405 106.596792,23.9470405 C108.223514,23.9470405 108.938285,25.2299294 108.938285,26.7703804 L108.938285,35.9786353 L112.564725,35.7506026 L112.564725,25.8008314 C112.564725,22.7215699 110.565007,20.8120013 107.567895,20.8120013 C105.540244,20.8120013 104.340742,21.2680667 103.113306,22.9217137 L103.054153,22.9217137 L103.054153,20.9251974 L99.6281776,21.2680667 L99.6281776,35.9786353 Z M96.6869328,20.8120013 L93.0604929,21.2680667 L93.0604929,29.5067725 C93.0604929,31.331034 92.0039452,33.0716288 89.7199618,33.0716288 C88.0915967,33.0716288 87.378468,31.7870993 87.378468,30.2482889 L87.378468,20.8120013 L83.7520282,21.2680667 L83.7520282,31.2178379 C83.7520282,34.2970993 85.7501029,36.206668 88.7488581,36.206668 C90.7765095,36.206668 91.9760116,35.7506026 93.2034473,34.0969556 L93.2609577,34.0969556 L93.2609577,35.9786353 L96.6869328,35.7506026 L96.6869328,20.8120013 Z M79.1824183,14.9668183 L76.7259037,17.3898706 L79.1824183,19.8129229 L81.6389328,17.3898706 L79.1824183,14.9668183 Z M77.2977212,21.2680667 L80.924161,20.9251974 L80.924161,36.3198641 C80.924161,39.3991255 78.9540199,41.3382235 75.7268664,41.3382235 C75.2700697,41.3382235 74.8428498,41.3103346 74.4419203,41.2808052 L73.3278622,38.1162366 C73.613771,38.145766 73.8996797,38.2015438 74.3860531,38.2015438 C75.9552647,38.2015438 77.2977212,37.4321386 77.2977212,35.6652954 L77.2977212,21.2680667 Z M64.2477959,28.8800928 C64.1919286,28.5372235 64.1919286,28.2238837 64.1919286,27.9105438 C64.3907502,25.6876353 66.2179369,23.8338444 68.5035635,23.8338444 C69.4730241,23.8338444 70.3586838,24.089766 71.0438788,24.7738641 L64.2477959,28.8800928 Z M73.2424183,31.189949 C71.7290739,32.1857464 70.3586838,32.8993739 68.5035635,32.8993739 C66.7618207,32.8993739 65.961605,32.0446614 65.6756963,31.4458706 L75.6134888,25.2873477 C74.3285427,22.6083739 71.7011402,20.8120013 68.7023851,20.8120013 C64.4186838,20.8120013 60.6492896,24.1471843 60.6492896,28.5093346 C60.6492896,32.871485 64.4186838,36.206668 68.7023851,36.206668 C70.8450573,36.206668 73.0140199,35.5225699 74.7853394,34.2970993 L73.2424183,31.189949 Z M44.2588332,35.7506026 L49.4561278,35.7506026 C54.081605,35.7506026 59.2213892,32.3858902 59.2213892,25.8287203 C59.2213892,20.469132 55.0247751,16.1922889 50.1988332,16.1922889 L44.2588332,16.1922889 L44.2588332,35.7506026 Z M48.0282274,32.1299686 L48.0282274,19.8129229 L49.8554141,19.8129229 C52.9971237,19.8129229 55.2811071,22.4935373 55.2811071,25.8287203 C55.2811071,28.9375111 53.4818539,32.1299686 50.0263021,32.1299686 L48.0282274,32.1299686 Z";
      } else if (this.product === 12) {
        return "M122.075462,20.8101967 L118.449022,21.2662621 L118.449022,29.5066085 C118.449022,31.3308699 117.390832,33.0698242 115.106848,33.0698242 C113.480126,33.0698242 112.765354,31.7869353 112.765354,30.2464843 L112.765354,20.8101967 L109.138915,21.2662621 L109.138915,31.2176739 C109.138915,34.2952948 111.138632,36.2065039 114.135744,36.2065039 C116.163396,36.2065039 117.362898,35.7504386 118.590334,34.0967915 L118.647844,34.0967915 L118.647844,35.9784712 L122.075462,35.7504386 L122.075462,20.8101967 Z M90.8900515,28.5091706 C90.8900515,32.8713209 94.6610888,36.2065039 98.94479,36.2065039 C103.226848,36.2065039 106.996242,32.8713209 106.996242,28.5091706 C106.996242,24.1470203 103.226848,20.8101967 98.94479,20.8101967 C94.6610888,20.8101967 90.8900515,24.1470203 90.8900515,28.5091706 L90.8900515,28.5091706 Z M94.3176697,28.5091706 C94.3176697,26.0287 96.4899187,24.1174908 98.94479,24.1174908 C101.399661,24.1174908 103.570267,26.0287 103.570267,28.5091706 C103.570267,30.9896412 101.399661,32.8992098 98.94479,32.8992098 C96.4899187,32.8992098 94.3176697,30.9896412 94.3176697,28.5091706 L94.3176697,28.5091706 Z M77.0431967,28.5091706 C77.0431967,26.1418961 78.812873,24.1174908 81.2398108,24.1174908 C83.6667485,24.1174908 85.438068,26.1418961 85.438068,28.5091706 C85.438068,30.8748046 83.6667485,32.8992098 81.2398108,32.8992098 C78.812873,32.8992098 77.0431967,30.8748046 77.0431967,28.5091706 L77.0431967,28.5091706 Z M85.2951137,36.0916673 L88.7210888,35.7504386 L88.7210888,15.7360595 L85.094649,16.1921248 L85.094649,22.3506477 C83.7538357,21.2383732 82.2388481,20.8101967 80.7830141,20.8101967 C76.6439104,20.8101967 73.6155784,24.488249 73.6155784,28.5091706 C73.6155784,32.5284516 76.6439104,36.2065039 80.7830141,36.2065039 C82.782732,36.2065039 83.7801261,35.6930203 85.2951137,34.1820987 L85.2951137,36.0916673 Z M62.6491718,31.1028373 C62.6491718,29.8199484 64.021205,29.0210137 65.3045079,29.0210137 C66.5894539,29.0210137 67.9614871,29.8199484 67.9614871,31.1028373 C67.9614871,32.4152556 66.5894539,33.1846608 65.3045079,33.1846608 C64.021205,33.1846608 62.6491718,32.4152556 62.6491718,31.1028373 L62.6491718,31.1028373 Z M60.7940515,24.6883928 C62.1085743,24.1749092 63.4773212,23.8336804 64.9052216,23.8336804 C66.5894539,23.8336804 68.0189975,24.202798 68.0189975,26.1714255 C68.0189975,26.5421837 67.9614871,26.8259941 67.9335535,27.139334 C66.5335867,26.4273471 65.5049726,26.1714255 63.9341178,26.1714255 C61.2229145,26.1714255 59.022732,28.4796412 59.022732,31.1028373 C59.022732,34.4101314 61.4217361,36.2065039 64.5059353,36.2065039 C65.8483917,36.2065039 67.1333378,35.6930203 68.1323751,34.8383078 L68.1323751,36.0916673 L71.4466158,35.7504386 L71.4466158,24.8868961 C71.4466158,21.9520007 68.5891718,20.8101967 65.9897029,20.8101967 C64.5930224,20.8101967 63.1634788,20.9529222 61.7930888,21.2104843 L60.7940515,24.6883928 Z M57.3384996,30.7320791 C56.3115286,31.5589026 55.0824498,32.3578373 53.511595,32.3578373 C50.2269311,32.3578373 47.486151,29.6214451 47.486151,25.9712817 C47.486151,22.6639876 49.8851552,19.5847261 53.3407071,19.5847261 C54.9690722,19.5847261 56.2819519,20.1556281 57.310566,20.9808111 L56.6812382,16.4480464 C55.8826656,15.9640922 54.4547651,15.7360595 53.511595,15.7360595 C47.6586822,15.7360595 43.5458689,20.3262425 43.5458689,25.9712817 C43.5458689,31.6737392 47.571595,36.2065039 53.6266158,36.2065039 C54.5122755,36.2065039 55.9960432,35.9505824 56.8241925,35.4649876 L57.3384996,30.7320791 Z";
      } else if (this.product === 14) {
        return "M119.751057,31.1034935 C119.751057,32.4142712 121.121447,33.185317 122.406393,33.185317 C123.691339,33.185317 125.061729,32.4142712 125.061729,31.1034935 C125.061729,29.8206046 123.691339,29.0216699 122.406393,29.0216699 C121.121447,29.0216699 119.751057,29.8206046 119.751057,31.1034935 L119.751057,31.1034935 Z M117.895937,24.6874085 L118.894974,21.2095 C120.263721,20.9535784 121.693265,20.8108529 123.091588,20.8108529 C125.691057,20.8108529 128.546858,21.9510163 128.546858,24.8875523 L128.546858,35.7510948 L125.234261,36.0923235 L125.234261,34.8373235 C124.235223,35.6936765 122.948634,36.2055196 121.607821,36.2055196 C118.523622,36.2055196 116.124617,34.4107876 116.124617,31.1034935 C116.124617,28.4802974 118.323157,26.1704412 121.036003,26.1704412 C122.606858,26.1704412 123.633829,26.4263627 125.033796,27.1399902 C125.061729,26.8266503 125.120883,26.5411993 125.120883,26.1704412 C125.120883,24.2034542 123.691339,23.8326961 122.007107,23.8326961 C120.579207,23.8326961 119.208817,24.1755654 117.895937,24.6874085 L117.895937,24.6874085 Z M110.784368,20.924049 L107.358393,21.2669183 L107.358393,35.9774869 L110.984833,35.7510948 L110.984833,28.7936373 C110.984833,26.2852778 112.212269,24.6595196 114.982626,24.6595196 L116.237995,20.8108529 C113.725613,20.8403824 112.098891,21.2948072 110.841879,23.5488856 L110.784368,23.5488856 L110.784368,20.924049 Z M104.61597,20.8108529 L100.98953,21.2669183 L100.98953,29.5056242 C100.98953,31.3315261 99.9329826,33.0704804 97.6489992,33.0704804 C96.0222772,33.0704804 95.3075054,31.7875915 95.3075054,30.2471405 L95.3075054,20.8108529 L91.6810656,21.2669183 L91.6810656,31.2166895 C91.6810656,34.295951 93.6807834,36.2055196 96.6778954,36.2055196 C98.7039037,36.2055196 99.905049,35.7510948 101.132485,34.0958072 L101.189995,34.0958072 L101.189995,35.9774869 L104.61597,35.7510948 L104.61597,20.8108529 Z M82.9707087,21.2669183 L81.5428083,21.2669183 L80.7442357,24.403598 L82.9707087,24.403598 L82.9707087,31.359415 C82.9707087,34.581402 85.1988249,36.2055196 88.2534473,36.2055196 C88.710244,36.2055196 89.3395718,36.1776307 89.6813477,36.0923235 L90.5670075,32.8424477 C90.1677212,32.8703366 89.7109245,32.899866 89.3116382,32.899866 C87.1968996,32.899866 86.5971485,31.9860948 86.5971485,30.5900098 L86.5971485,24.403598 L89.8818124,24.403598 L89.8818124,21.2669183 L86.5971485,21.2669183 L86.5971485,17.1328007 L82.9707087,18.7585588 L82.9707087,21.2669183 Z M79.3442689,35.7510948 L79.3442689,15.7367157 L75.717829,16.192781 L75.717829,35.9774869 L79.3442689,35.7510948 Z M72.8899618,20.8108529 L69.263522,21.2669183 L69.263522,29.5056242 C69.263522,31.3315261 68.2086174,33.0704804 65.9229909,33.0704804 C64.2962689,33.0704804 63.5814971,31.7875915 63.5814971,30.2471405 L63.5814971,20.8108529 L59.9550573,21.2669183 L59.9550573,31.2166895 C59.9550573,34.295951 61.953132,36.2055196 64.9518871,36.2055196 C66.9795386,36.2055196 68.1790407,35.7510948 69.4064763,34.0958072 L69.4639867,34.0958072 L69.4639867,35.9774869 L72.8899618,35.7510948 L72.8899618,20.8108529 Z M57.3292979,30.7327353 C56.3006838,31.5595588 55.0732481,32.3568529 53.5023934,32.3568529 C50.2177295,32.3568529 47.4769494,29.6204608 47.4769494,25.9719379 C47.4769494,22.6630033 49.8759535,19.5853824 53.3298622,19.5853824 C54.9582274,19.5853824 56.2711071,20.1546438 57.2997212,20.9814673 L56.6703934,16.4487026 C55.8718207,15.9631078 54.4439203,15.7367157 53.5023934,15.7367157 C47.6478373,15.7367157 43.5350241,20.3268987 43.5350241,25.9719379 C43.5350241,31.6727549 47.5623934,36.2055196 53.615771,36.2055196 C54.5014307,36.2055196 55.9851983,35.949598 56.8133477,35.4656438 L57.3292979,30.7327353 Z M118.415173,16.2288725 L120.240717,15.0985523 C120.375456,15.5939902 120.644933,15.9877157 121.055721,16.2830098 C121.464866,16.5766634 122.020252,16.7062647 122.726808,16.6964216 C123.412003,16.6865784 123.959173,16.5536961 124.368319,16.2682451 C124.777464,15.9827941 125.0568,15.5939902 125.209613,15.0985523 L127.038443,16.2288725 C126.770609,17.2541993 126.261232,18.0203235 125.51031,18.5239641 C124.757746,19.0276046 123.829364,19.2786046 122.726808,19.2786046 C121.602891,19.2786046 120.664651,19.0276046 119.913729,18.5239641 C119.161165,18.0203235 118.661646,17.2541993 118.415173,16.2288725 L118.415173,16.2288725 Z";
      } else {
        return "";
      }
    }
  }
};
</script>
<style scoped>
.fil1 {
  fill: #fefefe;
}

.fil4 {
  fill: #ffed00;
}

.fil10 {
  fill: white;
}

.fil0 {
  fill: #002b7f;
}

.fil2 {
  fill: #fefefe;
  fill-rule: nonzero;
}

.fil5 {
  fill: #2b2a29;
  fill-rule: nonzero;
}

.fil3 {
  fill: #264796;
  fill-rule: nonzero;
}

.fil7 {
  fill: #eb001b;
  fill-rule: nonzero;
}

.fil8 {
  fill: #f79e1b;
  fill-rule: nonzero;
}

.fil6 {
  fill: #ff5f00;
  fill-rule: nonzero;
}

.fil9 {
  fill: white;
  fill-rule: nonzero;
}

.img-card {
  width: 70% !important;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .img-card {
    width: 70% !important;
    height: 200px;
  }
}

@media (min-width: 1688px) {
  .img-card {
    width: 50% !important;
  }
}

@media (min-width: 1680px) {
  .img-card {
    width: 50% !important;
  }
}

@media (min-width: 1680px) and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .img-card {
    width: 50% !important;
  }
}
</style>
